<script setup lang="ts">
interface SuccessProps {
  title?: string;
}
const props = defineProps<SuccessProps>();
const emit = defineEmits(["redirect"]);

const { t } = useI18n();
</script>

<template>
  <div class="flex flex-col w-full justify-center items-center">
    <div class="w-[64px] h-[64px] flex justify-center items-center rounded-full bg-[var(--base-success-color)]">
      <IconCheck :width="24" :height="24" fill="#ffff" />
    </div>
    <div class="my-6 flex flex-col justify-center items-center">
      <span class="text-main font-bold text-2xl">{{ t('pages.events.appreciation') }}</span>
      <span class="text-base mt-4 text-secondary text-center">
        {{ t('pages.events.success_purchased', { subscription: props.title }) }}
      </span>
    </div>
    <slot name="action">
      <BaseButton
        type="primary"
        name="redirect-to-event"
        class="font-bold text-white text-xs sm:text-base"
        @click="() => emit('redirect')"
      >
        {{ t('labels.go_to_event') }}
      </BaseButton>
    </slot>
  </div>
</template>
